import { ExternalLink, Music2 } from "lucide-react";
import KineticHeading from "@/components/KineticHeading";
import Reveal from "@/components/Reveal";

const playlistUrl = "https://open.spotify.com/playlist/22y4A7dwwsj816hJc6cx7T";
const embedUrl = "https://open.spotify.com/embed/playlist/22y4A7dwwsj816hJc6cx7T?utm_source=generator";

export default function Playlist() {
  return (
    <div className="px-5 pb-28 pt-32 md:px-8 md:pt-40" data-testid="playlist-page">
      <section className="mx-auto max-w-7xl">
        <Reveal>
          <p className="flex items-center gap-3 text-xs uppercase tracking-[0.35em] text-cocoa/50" data-testid="playlist-eyebrow"><Music2 size={16} /> Songs for soft chapters</p>
        </Reveal>
        <div className="mt-6 grid gap-10 lg:grid-cols-[1fr_0.65fr] lg:items-end">
          <KineticHeading testId="playlist-kinetic-heading" lines={["The Almost,", "Always romance", "playlist."]} className="font-display text-6xl font-light leading-[0.88] tracking-[-0.04em] md:text-8xl" />
          <Reveal delay={0.2}>
            <p className="text-base leading-8 text-cocoa/65 md:text-lg" data-testid="playlist-description">Twenty-four songs that brought Almost, Always to life and helped me form these characters I love so much.</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto mt-16 grid max-w-7xl gap-8 lg:grid-cols-[0.85fr_1.15fr]" data-testid="spotify-playlist-section">
        <Reveal>
          <div className="rounded-[3rem] border border-cocoa/10 bg-cocoa p-4 shadow-[0_30px_80px_rgba(43,33,36,0.16)]" data-testid="playlist-artwork-panel">
            <img src="/playlist-artwork.webp" alt="Morgan Ella's handwritten romance playlist track list" data-testid="playlist-artwork-image" className="max-h-[820px] w-full rounded-[2.3rem] object-contain" />
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="flex h-full flex-col justify-between rounded-[3rem] border border-cocoa/10 bg-sky/70 p-6 md:p-10" data-testid="spotify-player-panel">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-cocoa/45">Listen while you read</p>
              <h2 className="mt-4 font-display text-5xl font-light leading-none" data-testid="spotify-player-title">Press play, open a book.</h2>
              <p className="mt-5 max-w-lg text-sm leading-7 text-cocoa/65" data-testid="spotify-player-description">The full playlist is available below and on Spotify, from “Lover” by G Flip to “How To Go To Confession” by Sabrina Carpenter.</p>
            </div>
            <iframe
              title="Morgan Ella romance playlist on Spotify"
              data-testid="spotify-playlist-embed"
              src={embedUrl}
              width="100%"
              height="352"
              className="mt-8 rounded-2xl border-0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            />
            <a href={playlistUrl} target="_blank" rel="noreferrer" data-testid="spotify-listen-link" className="group mt-8 inline-flex w-fit items-center gap-3 rounded-full bg-cocoa px-7 py-4 text-sm text-white transition-transform duration-300 hover:scale-105">
              Listen on Spotify <ExternalLink size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
